<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-loading"];
const _hoisted_2 = { class: "magic-noise__inner" };
import { onMounted, onUnmounted, watch, shallowRef } from "vue";
import { useResizeObserver, useDebounceFn } from "@vueuse/core";
import { useNoiseApi } from "../composables/private/useNoiseApi";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicNoise",
  props: {
    options: { type: Object, required: false },
    pause: { type: Boolean, required: false, default: false }
  },
  setup(__props) {
    const canvasRef = shallowRef(void 0);
    const offCanvasRef = shallowRef(void 0);
    const noiseApi = useNoiseApi({
      canvasRef,
      offCanvasRef,
      options: __props.options
    });
    const {
      initialize,
      drawControls,
      transferControls,
      throttledDraw,
      throttledRotateAndTransfer,
      isReady
    } = noiseApi;
    useResizeObserver(canvasRef, useDebounceFn(initialize, 100));
    watch(
      () => __props.pause,
      (pause) => {
        if (pause) {
          drawControls.value?.pause();
          transferControls.value?.pause();
        } else {
          drawControls.value?.resume();
          transferControls.value?.resume();
        }
      }
    );
    onMounted(() => {
      throttledDraw();
      throttledRotateAndTransfer();
    });
    onUnmounted(() => {
      isReady.value = false;
      transferControls.value?.pause();
      drawControls.value?.pause();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "magic-noise",
        "data-loading": !_unref(isReady)
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode(
            "canvas",
            {
              ref_key: "canvasRef",
              ref: canvasRef,
              class: "magic-noise__canvas"
            },
            null,
            512
            /* NEED_PATCH */
          ),
          _createElementVNode(
            "canvas",
            {
              ref_key: "offCanvasRef",
              ref: offCanvasRef,
              class: "magic-noise__off-canvas"
            },
            null,
            512
            /* NEED_PATCH */
          )
        ])
      ], 8, _hoisted_1);
    };
  }
});
</script>

<style>
:root {
  --magic-noise-loading-transition: color 300ms ease, opacity 300ms ease;
}

.magic-noise {
  position: relative;
  user-select: none;
  transition: var(--magic-noise-loading-transition);
  background: var(--magic-noise-background, #000);
  &[data-loading='true'] {
    background: var(--magic-noise-loading-background, #000);
    & > .magic-noise__inner {
      opacity: 0;
    }
  }
}

.magic-noise__inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: var(--magic-noise-loading-transition);
}

.magic-noise__canvas {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  object-fit: cover;
}

.magic-noise__off-canvas {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
  pointer-events: none;
}
</style>
